/*
  © 2024 KondaSoft
  https://www.kondasoft.com
  CODE: prices rendered with the UAE dirham sign (see snippets/code-money.liquid)
*/

function codeMoney (cents, plain) {
  const m = window.Shopify.formatMoney(cents).match(/[\d,]+(\.\d+)?/)
  const n = (m ? m[0] : '').replace(/\.00$/, '')
  if (plain) return `<span class="code-money code-money--plain" dir="ltr">${n}</span>`
  const sign = document.querySelector('.code-aed')
  const label = document.documentElement.lang === 'ar' ? 'درهم' : 'AED'
  return `<span class="code-money" dir="ltr">${sign ? sign.outerHTML : ''}<span class="visually-hidden">${label}</span><span class="code-money__n">${n}</span></span>`
}

class ProductForm extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')
    this.productOptions = this.form.querySelectorAll('.product-options [name*="option"]')
    this.atcBtn = this.form.querySelector('.btn-atc')
    this.buyBtn = this.form.querySelector('.btn-buy')

    this.form.addEventListener('submit', event => this.onSubmit(event))

    this.productOptions.forEach(elem =>
      elem.addEventListener('change', event => this.onChangeProductOption(event)))

    this.buyBtn?.addEventListener('click', event => this.onClickBuyBtn(event))
  }

  async onChangeProductOption (event) {
    event.preventDefault()

    const selectedOptions = []

    this.productOptions.forEach(elem => {
      if (elem.type === 'radio' && elem.checked) {
        selectedOptions.push(elem.value)
      } else if (elem.type === 'select-one') {
        selectedOptions.push(elem.value)
      }
    })

    const selectedVariant = JSON.parse(this.form.dataset.variants).find(variant =>
      JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    this.adjustPricing(selectedVariant)
    this.adjustButtons(selectedVariant)

    if (selectedVariant) {
      this.querySelector('[name="id"]').value = selectedVariant.id

      if (this.closest('.product-template')) {
        const url = new URL(window.location)
        url.searchParams.set('variant', selectedVariant.id)
        window.history.replaceState({}, '', url)
      }

      window.dispatchEvent(new CustomEvent('kt.product.variant.change', {
        detail: selectedVariant
      }))
    }
  }

  adjustPricing (selectedVariant) {
    if (!selectedVariant) return

    const comparePrice = this.form.querySelector('.product-price-compare')
    const finalPrice = this.form.querySelector('.product-price-final')
    const compareBadge = this.form.querySelector('.product-price-sale-badge')
    const soldOutBadge = this.form.querySelector('.product-price-sold-out-badge')
    const ar = document.documentElement.lang === 'ar'

    if (selectedVariant.compare_at_price > selectedVariant.price) {
      comparePrice.innerHTML = `<span class="visually-hidden">${window.theme.locales.product.regular_price || ''}</span>${codeMoney(selectedVariant.compare_at_price, true)}`
      comparePrice.removeAttribute('hidden')
      finalPrice.innerHTML = `<span class="visually-hidden">${window.theme.locales.product.sale_price}</span>${codeMoney(selectedVariant.price)}`
      finalPrice.classList.add('product-price-final-sale')
      const savings = Math.floor((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price)
      compareBadge.innerHTML = `${ar ? 'وفّر' : 'Save'} <span dir="ltr">${savings}%</span>`
      compareBadge.removeAttribute('hidden')
    } else {
      comparePrice.innerHTML = ''
      comparePrice.setAttribute('hidden', 'hidden')
      finalPrice.innerHTML = codeMoney(selectedVariant.price)
      finalPrice.classList.remove('product-price-final-sale')
      compareBadge.textContent = ''
      compareBadge.setAttribute('hidden', 'hidden')
    }

    if (selectedVariant.available) {
      soldOutBadge.setAttribute('hidden', 'hidden')
    } else {
      soldOutBadge.removeAttribute('hidden')
    }
  }

  adjustButtons (selectedVariant) {
    if (selectedVariant) {
      if (selectedVariant.available) {
        this.atcBtn.removeAttribute('disabled')
        this.buyBtn?.removeAttribute('disabled')
        this.atcBtn.innerHTML = window.theme.locales.product.add_to_cart
      } else {
        this.atcBtn.setAttribute('disabled', 'disabled')
        this.buyBtn?.setAttribute('disabled', 'disabled')
        this.atcBtn.innerHTML = window.theme.locales.product.sold_out
      }
    } else {
      this.atcBtn.setAttribute('disabled', 'disabled')
      this.buyBtn?.setAttribute('disabled', 'disabled')
      this.atcBtn.innerHTML = window.theme.locales.product.unavailable
    }
  }

  async onSubmit (event) {
    event.preventDefault()

    this.atcBtn.classList.add('loading')
    this.atcBtn.disabled = true
    this.atcBtn.setAttribute('aria-busy', 'true')

    const formData = new FormData(this.form)

    await document.querySelector('cart-container').add(formData)

    this.atcBtn.classList.remove('loading')
    this.atcBtn.disabled = false
    this.atcBtn.setAttribute('aria-busy', 'false')
  }

  onClickBuyBtn () {
    this.buyBtn.classList.add('loading')
    const variantId = this.form.querySelector('[name="id"]').value
    const qty = Number(this.form.querySelector('input[name="quantity"]')?.value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
  }
}
customElements.define('product-form', ProductForm)
